import axiosWithAuth from '../utils/axiosWithAuth';

/**
 * Get property details by ID
 * @param {string} propertyId - The ID of the property to fetch
 * @returns {Promise<Object>} - The property data
 */
export const getPropertyById = async (propertyId) => {
  try {
    if (!propertyId) {
      throw new Error('Property ID is required');
    }
    
    const api = axiosWithAuth();
    const response = await api.get(`/properties/${propertyId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching property details:', error);
    throw error;
  }
};

/**
 * Get all properties for the current user
 * @returns {Promise<Object>} - The properties data
 */
export const getUserProperties = async () => {
  try {
    const api = axiosWithAuth();
    const response = await api.get('/properties');
    
    // Validate response data structure
    if (response?.data?.data && Array.isArray(response.data.data)) {
      // Filter out items with null or undefined _id
      const validProperties = response.data.data.filter(property => 
        property && (property._id || property.id)
      );
      
      // Create a new response with validated data
      return {
        ...response.data,
        data: validProperties
      };
    }
    
    return response.data;
  } catch (error) {
    console.error('Error fetching user properties:', error);
    throw error;
  }
};

const propertyService = {
  getUserProperties,
  getPropertyById
};

export default propertyService;
 